// @ts-nocheck

import { sendReport } from '../../actions/report';
import { getAuthManager } from '../../managers/authManager';
import { selectUserConnected } from '../../selectors/user/userPrimary.selector';
import { ExternalLinkActionTypes } from '../../types/actions/externallink';
import { openUrl } from '../../utils/navigation';
import { type HandlerProps } from '../synchronousMiddleware';

// Ce flag sert à empêcher une seconde navigation tant que la première n'est pas terminée pour éviter le spam du bouton
let redirectPending = false;

export const handledActionTypes = [ExternalLinkActionTypes.OPEN];

const doRedirect = async (getState, action, dispatch, onExternalLinkOpen) => {
  if (!redirectPending) {
    redirectPending = true;

    const state = getState();
    const connected = selectUserConnected(state);

    let { url } = action.payload ?? {};
    const { options } = action.payload ?? {};
    let sep = url.indexOf('?') !== -1 ? '&' : '?';

    if (options?.auth && connected) {
      const ott = await getAuthManager().getOTT();

      if (ott) {
        url += sep;
        sep = '&';
        url += `ott=${ott}`;
      } else {
        dispatch(sendReport({ message: 'Error generating OTT', payload: action.payload }));
      }
    }

    if (options?.external) {
      url += sep;
      sep = '&';
      url += 'external=1';
    }

    // On réactive la navigation juste avant la navigation effective
    redirectPending = false;
    if (onExternalLinkOpen) {
      onExternalLinkOpen(url);
    } else {
      openUrl(url, options);
    }
  } else {
    dispatch(sendReport({ message: 'external url try to open while already one pending', payload: action.payload }));
  }
};

const externalLinkMiddlewareHandler = ({
  store: { dispatch, getState },
  action,
  params: { onExternalLinkOpen },
}: HandlerProps) => {
  if (~handledActionTypes.indexOf(action.type)) {
    if (action.type === ExternalLinkActionTypes.OPEN) {
      doRedirect(getState, action, dispatch, onExternalLinkOpen);
    }
  }
};

export default externalLinkMiddlewareHandler;
